document.addEventListener('DOMContentLoaded', function() {
  const sectionId = window.pahlowmediaSectionId;
  if (!sectionId) return;

  // Helper function to check if we're in mobile/tablet mode
  function isMobileTabletMode() {
    return window.innerWidth <= 1024;
  }

  // Initialize image visibility and slider functionality
  function initializeImageSlider() {
    const imagesContainer = document.querySelector(`#shopify-section-${sectionId} .product__images`);
    
    if (!imagesContainer) return;

    const imgPrevBtn = imagesContainer.querySelector('.prev-btn:not(.mobile-nav)');
    const imgNextBtn = imagesContainer.querySelector('.next-btn:not(.mobile-nav)');
    const mobileImgPrevBtn = imagesContainer.querySelector('.prev-btn.mobile-nav');
    const mobileImgNextBtn = imagesContainer.querySelector('.next-btn.mobile-nav');
    const imagesSlider = imagesContainer.querySelector('.images-slider');
    const images = Array.from(imagesContainer.querySelectorAll('.product__image'));
    const featuredImage = document.querySelector(`#shopify-section-${sectionId} .product__featured-image img`);
    const imageCounter = imagesContainer.querySelector('.image-counter');
    const currentImageSpan = imageCounter ? imageCounter.querySelector('.current-image') : null;
    
    let currentImageIndex = 0;
    let visibleImagesCount = 5; // Number of visible thumbnails at a time
    let currentScrollPosition = 0;

    // Function to check if navigation buttons should be visible
    function updateNavigationButtonsVisibility() {
      if (!isMobileTabletMode()) {
        if (imgPrevBtn) {
          imgPrevBtn.style.display = currentScrollPosition > 0 ? 'flex' : 'none';
        }
        if (imgNextBtn) {
          imgNextBtn.style.display = currentScrollPosition + visibleImagesCount < images.length ? 'flex' : 'none';
        }
      }
    }

    // Function to scroll thumbnails
    function scrollThumbnails(direction) {
      if (direction === 'prev') {
        currentScrollPosition = Math.max(0, currentScrollPosition - 1);
      } else {
        currentScrollPosition = Math.min(images.length - visibleImagesCount, currentScrollPosition + 1);
      }

      const scrollAmount = currentScrollPosition * (50 + 8); // 50px for image height + 8px for gap
      if (imagesSlider) {
        imagesSlider.style.transform = `translateY(-${scrollAmount}px)`;
      }
      updateNavigationButtonsVisibility();
    }

    // Function to update active image for mobile/tablet
    function updateActiveImage() {
      const isMobileTablet = isMobileTabletMode();
      
      if (isMobileTablet) {
        images.forEach((image, index) => {
          if (index === currentImageIndex) {
            image.classList.add('active');
          } else {
            image.classList.remove('active');
          }
        });
        
        // Update counter
        if (currentImageSpan) {
          currentImageSpan.textContent = currentImageIndex + 1;
        }
      }
    }

    // Function to navigate to specific image
    function navigateToImageByIndex(index) {
      if (index < 0 || index >= images.length) return;
      
      const isMobileTablet = isMobileTabletMode();
      currentImageIndex = index;
      const targetImage = images[index];
      const targetImg = targetImage.querySelector('img');
      
      if (!targetImg) return;
      
      const imgSrc = targetImg.getAttribute('src');
      const imgSrcset = targetImg.getAttribute('srcset');
      const imgAlt = targetImg.getAttribute('alt');
      
      // Update featured image (desktop only)
      if (featuredImage && !isMobileTablet) {
        featuredImage.setAttribute('src', imgSrc);
        if (imgSrcset) {
          featuredImage.setAttribute('srcset', imgSrcset);
        }
        featuredImage.setAttribute('alt', imgAlt || '');
      }
      
      // Update active class for thumbnails
      images.forEach((img, idx) => {
        const thumbnail = img.querySelector('img');
        if (thumbnail) {
          if (idx === index) {
            thumbnail.classList.add('active-thumbnail');
            img.classList.add('active');
          } else {
            thumbnail.classList.remove('active-thumbnail');
            img.classList.remove('active');
          }
        }
      });
      
      // Ensure the selected thumbnail is visible
      if (!isMobileTablet) {
        if (index < currentScrollPosition) {
          currentScrollPosition = index;
          scrollThumbnails('prev');
        } else if (index >= currentScrollPosition + visibleImagesCount) {
          currentScrollPosition = index - visibleImagesCount + 1;
          scrollThumbnails('next');
        }
      }
      
      // Update active image for mobile/tablet
      updateActiveImage();
    }

    // Function to navigate images
    function navigateToImage(direction) {
      let nextIndex;
      if (direction === 'prev') {
        nextIndex = currentImageIndex <= 0 ? images.length - 1 : currentImageIndex - 1;
      } else {
        nextIndex = currentImageIndex >= images.length - 1 ? 0 : currentImageIndex + 1;
      }
      navigateToImageByIndex(nextIndex);
    }

    // Set first image as active by default
    if (images.length > 0) {
      navigateToImageByIndex(0);
      updateNavigationButtonsVisibility();
    }

    // Add click handlers for mobile navigation
    if (mobileImgPrevBtn) {
      mobileImgPrevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        navigateToImage('prev');
      });
    }

    if (mobileImgNextBtn) {
      mobileImgNextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        navigateToImage('next');
      });
    }

    // Add click handlers for desktop navigation
    if (imgPrevBtn) {
      imgPrevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (!isMobileTabletMode()) {
          scrollThumbnails('prev');
        }
      });
    }

    if (imgNextBtn) {
      imgNextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (!isMobileTabletMode()) {
          scrollThumbnails('next');
        }
      });
    }

    // Add click handlers for thumbnails (desktop only)
    images.forEach((image, index) => {
      image.addEventListener('click', function() {
        if (!isMobileTabletMode()) {
          navigateToImageByIndex(index);
        }
      });
    });

    // Add click handlers for featured image navigation buttons
    const thumbnailPrevBtn = document.querySelector(`#shopify-section-${sectionId} .thumbnail-prev-btn`);
    const thumbnailNextBtn = document.querySelector(`#shopify-section-${sectionId} .thumbnail-next-btn`);

    if (thumbnailPrevBtn) {
      thumbnailPrevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        navigateToImage('prev');
      });
    }

    if (thumbnailNextBtn) {
      thumbnailNextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        navigateToImage('next');
      });
    }

    // Handle window resize
    window.addEventListener('resize', function() {
      const isMobileTablet = isMobileTabletMode();
      if (isMobileTablet) {
        updateActiveImage();
        if (imagesSlider) {
          imagesSlider.style.transform = ''; // Reset transform
        }
      } else {
        updateNavigationButtonsVisibility();
      }
    });
  }

  // Image modal functionality
  function initializeImageModal() {
    const modal = document.getElementById('product-image-modal');
    const modalImg = document.getElementById('modal-image');
    const closeBtn = document.querySelector('.close-modal');
    const magnifyingGlass = document.querySelector(`#shopify-section-${sectionId} .magnifying-glass`);
    const featuredImage = document.querySelector(`#shopify-section-${sectionId} .product__featured-image img`);
    
    if (!modal || !modalImg) return;
    
    // Variables to keep track of current image in modal
    let currentImageIndex = 0;
    let productImages = [];
    
    // Function to update product images array
    function updateProductImages() {
      productImages = Array.from(document.querySelectorAll(`#shopify-section-${sectionId} .product__image img`));
      
      // Add featured image if not already in the array
      const featuredImg = document.querySelector(`#shopify-section-${sectionId} .product__featured-image img`);
      if (featuredImg && !productImages.includes(featuredImg)) {
        productImages.unshift(featuredImg);
      }
    }
    
    // Function to open modal with specific image
    function openImageModal(imgElement) {
      if (!imgElement) return;
      
      updateProductImages();
      
      // Find the index of the clicked image
      currentImageIndex = productImages.findIndex(img => img.src === imgElement.src);
      if (currentImageIndex === -1) currentImageIndex = 0;
      
      // Set modal image
      modalImg.src = imgElement.src;
      modalImg.srcset = imgElement.srcset || '';
      modalImg.alt = imgElement.alt || '';
      
      // Show modal
      modal.classList.add('show');
      document.body.style.overflow = 'hidden'; // Prevent scrolling
    }
    
    // Function to close modal
    function closeModal() {
      modal.classList.remove('show');
      document.body.style.overflow = ''; // Restore scrolling
    }
    
    // Add click event to magnifying glass
    if (magnifyingGlass) {
      magnifyingGlass.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (featuredImage) {
          openImageModal(featuredImage);
        }
      });
    }
    
    // Close modal when clicking close button
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }
    
    // Close when clicking outside the image
    if (modal) {
      modal.addEventListener('click', function(event) {
        if (event.target === modal) {
          closeModal();
        }
      });
    }
    
    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (!modal.classList.contains('show')) return;
      
      if (e.key === 'Escape') {
        closeModal();
      }
    });
  }

  // Initialize all functionality
  initializeImageSlider();
  initializeImageModal();
}); 